function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import path from 'path';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { startCase } from 'lodash';
import Icon from '../../../common/containers/icon';

// Keep styling consistent with Mapbox popovers
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  popoverBody: {
    padding: '10px'
  },
  row: {
    marginBottom: '5px'
  },
  span: {
    marginLeft: '5px',
    fontStyle: 'normal'
  },
  icon: {
    opacity: '0.25'
  }
};
const buildUrl = ({
  formID,
  formTypeIdentifier,
  cabinetIdentifier
}) => {
  if (formID && formTypeIdentifier && cabinetIdentifier) {
    return path.join('/cabinets', cabinetIdentifier, formTypeIdentifier, formID);
  }
  if (formID && formTypeIdentifier) {
    return path.join('/forms', formTypeIdentifier, formID);
  }
  if (formID) {
    return path.join('/directForms', formID);
  }
  return null;
};
const FeaturePopover = ({
  isOpen,
  target: _target = null,
  container: _container = null,
  feature: _feature = null,
  onClose
}) => {
  const history = useHistory();
  const url = useMemo(() => buildUrl(_feature || {}), [_feature]);
  const displayFields = _feature === null || _feature === void 0 ? void 0 : _feature.displayFields;
  const formTitle = useMemo(() => {
    var _ref, _ref2, _titleField$value;
    const titleField = Array.isArray(displayFields) ? displayFields.find(f => f.identifier === 'title') : null;
    return (_ref = (_ref2 = (_titleField$value = titleField === null || titleField === void 0 ? void 0 : titleField.value) !== null && _titleField$value !== void 0 ? _titleField$value : _feature === null || _feature === void 0 ? void 0 : _feature.title) !== null && _ref2 !== void 0 ? _ref2 : _feature === null || _feature === void 0 ? void 0 : _feature.formTypeIdentifier) !== null && _ref !== void 0 ? _ref : 'Feature';
  }, [displayFields, _feature === null || _feature === void 0 ? void 0 : _feature.title, _feature === null || _feature === void 0 ? void 0 : _feature.formTypeIdentifier]);
  const bodyFields = useMemo(() => {
    const activityRow = _feature !== null && _feature !== void 0 && _feature.activityType ? [{
      identifier: 'activityType',
      label: 'Activity type',
      value: startCase(_feature.activityType)
    }] : [];
    const rest = Array.isArray(displayFields) ? displayFields.filter(f => f.identifier !== 'title') : [];
    return [...activityRow, ...rest];
  }, [_feature === null || _feature === void 0 ? void 0 : _feature.activityType, displayFields]);
  const handleNavigate = () => {
    if (!url) return;
    history.push(url);
    onClose();
  };
  if (!_target) return null;
  const containerNode = _container != null && _container.nodeType === 1 ? _container : undefined;
  return /*#__PURE__*/React.createElement(Popover
  // className ensures popover is visible above fullscreened map
  , {
    className: "arcgis-feature-popover",
    target: _target,
    container: containerNode,
    placement: "bottom",
    isOpen: isOpen,
    toggle: onClose,
    trigger: "legacy",
    style: {
      width: '320px'
    }
  }, /*#__PURE__*/React.createElement(PopoverHeader, null, /*#__PURE__*/React.createElement("strong", null, formTitle)), /*#__PURE__*/React.createElement(PopoverBody, {
    onClick: handleNavigate,
    style: _objectSpread(_objectSpread({}, styles.popoverBody), {}, {
      cursor: url ? 'pointer' : 'default'
    })
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/React.createElement("div", null, bodyFields.length > 0 ? bodyFields.map(({
    identifier,
    label,
    value
  }) => /*#__PURE__*/React.createElement("div", {
    key: identifier || label,
    style: styles.row
  }, /*#__PURE__*/React.createElement("strong", null, `${label}:`), /*#__PURE__*/React.createElement("span", {
    style: styles.span
  }, String(value !== null && value !== void 0 ? value : '')))) : /*#__PURE__*/React.createElement(React.Fragment, null, (_feature === null || _feature === void 0 ? void 0 : _feature.fromDistance) != null && (_feature === null || _feature === void 0 ? void 0 : _feature.toDistance) != null && /*#__PURE__*/React.createElement("div", {
    style: styles.row
  }, /*#__PURE__*/React.createElement("strong", null, "Station:"), /*#__PURE__*/React.createElement("span", {
    style: styles.span
  }, `${_feature.fromDistance} – ${_feature.toDistance}`)), (_feature === null || _feature === void 0 ? void 0 : _feature.formID) && /*#__PURE__*/React.createElement("div", {
    style: styles.row
  }, /*#__PURE__*/React.createElement("strong", null, "Form:"), /*#__PURE__*/React.createElement("span", {
    style: styles.span
  }, _feature.formID)), /*#__PURE__*/React.createElement("div", {
    style: {
      opacity: 0.75
    }
  }, "Click to open"))), /*#__PURE__*/React.createElement(Icon, {
    glyph: "angle-right",
    style: styles.icon
  }))));
};
FeaturePopover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  target: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  container: PropTypes.instanceOf(Element),
  feature: PropTypes.shape({
    title: PropTypes.string,
    activityType: PropTypes.string,
    fromDistance: PropTypes.number,
    toDistance: PropTypes.number,
    formID: PropTypes.string,
    formTypeIdentifier: PropTypes.string,
    cabinetIdentifier: PropTypes.string,
    displayFields: PropTypes.arrayOf(PropTypes.shape({
      identifier: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
    }))
  }),
  onClose: PropTypes.func.isRequired
};
export default FeaturePopover;